import React from 'react';
import PropTypes from 'prop-types';
import { Card, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import paths from 'routes/paths';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import classNames from 'classnames';

const EcomStatItem = ({ stat, type }) => {
  return (
    <Col xs={6} className={`border-200 border-bottom border-end p-2`}>
      {stat.title === 'Total Jobs' ? (
        <Link to={paths.nursd_schedule_table(type, 'All')}>
          <h6 className="pb-1 text-700">{stat.title}</h6>
          <p className="font-sans-serif lh-1 mb-1 fs-7">{stat.total}</p>
        </Link>
      ) : (
        <Link to={paths.nursd_schedule_table(type, stat?.status)}>
          <h6 className="pb-1 text-700">
            {stat.title === 'Pending Approvals'
              ? 'Pending Timecard'
              : stat.title}
          </h6>
          <p className="font-sans-serif lh-1 mb-1 fs-7">{stat.total}</p>
          {/* <div className="d-flex align-items-center">
        <h6 className="fs-10 text-500 mb-0">{stat.subAmount}</h6>
        <h6
          className={classNames('fs-11 ps-3 mb-0', {
            'text-success': stat.type === 'up',
            'text-danger': stat.type === 'down',
            'text-primary': stat.type === 'standard',
            'text-warning': stat.type === 'warning',
            'text-info': stat.type === 'pending'
          })}
        >
          <FontAwesomeIcon icon="caret-up" className="me-1" />
          {stat.percent}%
        </h6>
      </div> */}
        </Link>
      )}
    </Col>
  );
};

EcomStatItem.propTypes = {
  type: PropTypes.any,
  stat: PropTypes.any,
  index: PropTypes.number,
  lastIndex: PropTypes.number
};

const EcomStat = ({ dashboardMatrix, type }) => {
  return (
    <div className="py-3 mb-3">
      <Card.Body className="py-3">
        <Row className="g-0">
          {dashboardMatrix?.data
            ?.filter?.(
              item =>
                item?.status !== 'Pending Approval' &&
                item?.status !== 'Pending Assignment'
            )
            ?.map((stat, index) => (
              <EcomStatItem
                key={stat.title}
                type={type}
                stat={stat}
                index={index}
                lastIndex={dashboardMatrix?.data?.length - 1}
              />
            ))}
        </Row>
      </Card.Body>
    </div>
  );
};

EcomStat.propTypes = {
  type: PropTypes.any,
  dashboardMatrix: PropTypes.any
};

export default EcomStat;
